import { ActionType } from '../types'
import { sustainabilityAssistant } from './sustainability'
// import { textileAssistant } from './textile'

export const assistants: Array<ActionType> = [sustainabilityAssistant] //textileAssistant
